import { Component } from './component';
import type { FrameworkProvider } from '../provider';

// eslint-disable-next-line @typescript-eslint/ban-types
export class Entity<Props = {}> extends Component<Props> {
  declare readonly framework: FrameworkProvider;
  declare readonly props: Props;
  readonly __isEntity = true;
}
